module.exports = __webpack_public_path__ + "img/server.318920d7.png";